// extracted by mini-css-extract-plugin
export default {"helloGo":"SongNames_helloGo__2OdDJ","songName":"SongNames_songName__SW-E2","searchByNameInput":"SongNames_searchByNameInput__QsG3-"};